"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testUser = exports.ROLE_ADMIN = exports.ROLE_QA = exports.ROLE_TAGGER = exports.User = exports.ROLE_NAME_ADMIN = exports.ROLE_NAME_QA = exports.ROLE_NAME_TAGGER = exports.PERMISSION_DEBUG = exports.PERMISSION_PUBLISH = exports.PERMISSION_READ = exports.PERMISSION_WRITE = void 0;
const partial_myid_user_dto_1 = require("./dto/partial-myid-user.dto");
exports.PERMISSION_WRITE = 'WRITE';
exports.PERMISSION_READ = 'READ';
exports.PERMISSION_PUBLISH = 'PUBLISH';
exports.PERMISSION_DEBUG = 'DEBUG';
exports.ROLE_NAME_TAGGER = 'Tagger';
exports.ROLE_NAME_QA = 'QA';
exports.ROLE_NAME_ADMIN = 'Admin';
class User {
    constructor(myIdUser, gssoMyid, gssoMyidUserdata) {
        this.myIdUser = myIdUser;
        this.gssoMyid = gssoMyid;
        this.gssoMyidUserdata = gssoMyidUserdata;
    }
    get id() {
        return this.myIdUser['relationship.employeeId'];
    }
    hasPermission(permission) {
        const roles = this.myIdUser.roles || [];
        return roles
            .flatMap(role => role.functionalAbilities.map(fa => fa.name))
            .includes(permission);
    }
}
exports.User = User;
exports.ROLE_TAGGER = {
    name: exports.ROLE_NAME_TAGGER,
    functionalAbilities: [{ name: exports.PERMISSION_READ }, { name: exports.PERMISSION_WRITE }],
};
exports.ROLE_QA = {
    name: exports.ROLE_NAME_QA,
    functionalAbilities: [
        { name: exports.PERMISSION_READ },
        { name: exports.PERMISSION_WRITE },
        { name: exports.PERMISSION_PUBLISH },
    ],
};
exports.ROLE_ADMIN = {
    name: exports.ROLE_NAME_ADMIN,
    functionalAbilities: [
        { name: exports.PERMISSION_READ },
        { name: exports.PERMISSION_WRITE },
        { name: exports.PERMISSION_PUBLISH },
        { name: exports.PERMISSION_DEBUG },
    ],
};
exports.testUser = new User(partial_myid_user_dto_1.TestMyIDUser, 'gsso-myid', 'gsso-myid-userdata');
//# sourceMappingURL=user.js.map